const passwordMatchRegExp = 'matchRegexp:^(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])(?=.{8,})';

export { 
    passwordMatchRegExp
}